import React, { useEffect, useState } from 'react';
import PasswordResetForm from 'components/authentication/passwordResetForm';
import AuthSplitLayout from 'layouts/authSplitLayout';
import { useTranslation } from 'react-i18next';
import LanguageButtons from 'components/navbar/top/languageBtn';
import { fetchLoginImage } from 'assets/js/common';
import { Spinner } from 'react-bootstrap';

const PasswordReset = () => {
  const { t } = useTranslation();
  const [bgImg, setBgImg] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadImage = async () => {
      const domainToUse = process.env.REACT_APP_DEFAULT_DOMAIN;
      const cacheKey = `cachedLoginBg_${domainToUse}`;

      const cached = localStorage.getItem(cacheKey);
      if (cached) {
        setBgImg(cached);
        setIsLoading(false);
        return;
      }

      const image = await fetchLoginImage();
      localStorage.setItem(cacheKey, image);
      setBgImg(image);
      setIsLoading(false);
    };

    loadImage();
  }, []);

  if (isLoading) {
    return (
      <div className="text-center my-5">
        <span>{t('loading')}</span>
        <Spinner animation="border" role="status" />
      </div>
    );
  }

  return (
    <>
      <div className="language-buttons">
        <LanguageButtons />
      </div>
      <AuthSplitLayout bgProps={{ image: bgImg }}>
        <div className="text-center">
          <h3>{t('resetPasswordLabel')}</h3>
        </div>
        <PasswordResetForm layout="split" hasLabel />
      </AuthSplitLayout>
    </>
  );
};

export default PasswordReset;
